document.documentElement.addEventListener('cart:refreshed', async e => {
  /* ___ Display popup info  ___ */
  displayShippingInfo();

  /* ___ Gift wrapping  ___ */
  displayGiftWrappingInfo();
  updateGiftWrapping();

  /* ___ Upgrade variant ___ */
  upgradeVariant();

  /* ___ Upgrade free gift ___ */
  updateFreeGift();
  toggleFreeProductsVisibility();

  // Remove choosen free gift if user click on "edit"
  let editButton = document.querySelector('.product-item-meta__edit-gift');
  if (editButton) {
    editButton.addEventListener('click', async function () {
      let productId = editButton.getAttribute('data-product-id');
      await removeProduct(productId);

      // Cart refresh
      refreshCart();
    });
  }

  // CHOOSE YOUR FREE GIFT - REMOVE PRODUCT IF CART TOTAL < MIN AMOUNT TO CHOOSE A GIFT
  await removeChosenFreeGift(e);
});

/* ________________ FUNCTIONS ________________ */

async function addGiftWrappingToCart(productId) {
  let formData = {
    'items': [{
      'id': productId,
      'quantity': 1,
      'properties': {
        '_giftWrapping': true
      }
    }]
  };
  await fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  });
}
function displayPopup(popup, infoButton) {
  if (window.matchMedia("(max-width: 767px)").matches) {
    // MOBILE
    infoButton.addEventListener('click', () => {
      popup.classList.toggle('is-open');
    });
  } else {
    // DESKTOP
    infoButton.addEventListener('mouseover', () => {
      popup.classList.add('is-open');
    });
    infoButton.addEventListener('mouseout', () => {
      popup.classList.remove('is-open');
    });
  }
}
function displayShippingInfo() {
  let infoButton = document.querySelector('.price-summary__item--estimated-shipping .price-summary__info');
  let infoPopup = document.querySelector('.shipping-popup');
  if (infoButton) {
    displayPopup(infoPopup, infoButton);
  }
}
function displayGiftWrappingInfo() {
  let giftWrappingInfoButton = document.querySelector('.price-summary__item--gift-wrapping .price-summary__info');
  let giftWrappingPopup = document.querySelector('.gift-wrapping-popup');
  if (giftWrappingInfoButton) {
    displayPopup(giftWrappingPopup, giftWrappingInfoButton);
  }
}
async function removeProduct(id) {
  let updates = {
    [id]: 0
  };
  await fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      updates
    })
  });
}
async function addProduct(id, qty) {
  let formData = {
    'items': [{
      'id': id,
      'quantity': qty
    }]
  };
  await fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  });
}
function refreshCart() {
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true
  }));
}
function upgradeVariant() {
  let buttons = document.querySelectorAll('.change-variant__change-button');
  buttons.forEach(button => {
    button.addEventListener('click', async () => {
      let productIdToRemove = button.getAttribute('data-current-variant-id');
      let productIdToAdd = button.getAttribute('data-higher-variant-id');
      let quantity = button.closest('.line-item__info').querySelector('.quantity-selector__input').value;
      try {
        // Remove current variant from cart
        await removeProduct(productIdToRemove);

        // Add new variant to cart
        await addProduct(productIdToAdd, quantity);
      } catch (e) {
        console.error('Error: ', e);
      }

      // Cart refresh
      refreshCart();
    });
  });
}
function updateFreeGift() {
  let freeGiftSettings = window.freeGiftSettings;
  //console.log("freeGiftSettings : ", freeGiftSettings);

  if (freeGiftSettings != null) {
    let minAmount = freeGiftSettings.minAmount;
    let firstVariantId = freeGiftSettings.firstVariantId;

    /* console.log("minAmount", minAmount);
    console.log("firstVariantId", firstVariantId);
    console.log("cart total : ", cartTotal); */

    // Get cart content
    fetch('/cart.js').then(response => response.json()).then(async data => {
      //console.log(data);
      let totalPrice = data.total_price / 100;
      let items = data.items;
      let giftIsAlreadyInCart = false;

      // Check if the gift is already in the cart
      if (items.find(item => item.variant_id == firstVariantId)) {
        giftIsAlreadyInCart = true;
      }
      if (totalPrice >= minAmount) {
        // If the total price is greater than the minAmount
        if (giftIsAlreadyInCart) {
          return;
        } else {
          // Add gift to cart
          await addProduct(firstVariantId, 1);
          refreshCart();
        }
      } else if (totalPrice < minAmount) {
        // If the total price is less than the minAmount
        if (giftIsAlreadyInCart) {
          // Remove gift from cart
          await removeProduct(firstVariantId);
          refreshCart();
        }
      } else if (totalPrice == 0) {
        // Remove gift from cart
        await removeProduct(firstVariantId);
        refreshCart();
      }
    }).catch(error => console.error('Error:', error));
  }
}
async function removeChosenFreeGift(e) {
  let chosenFreeProduct = window.chosenFreeProductSettings;
  let minAmount = chosenFreeProduct.minAmount;
  if (e.detail && e.detail.cart) {
    let items = e.detail.cart.items;
    let cartTotal = e.detail.cart.total_price;
    cartTotal = cartTotal.toFixed(2) / 100;
    const chosenItem = items.find(item => item.properties && item.properties.hasOwnProperty("_chosenFreeGift"));
    if (chosenFreeProduct && cartTotal < minAmount && chosenItem) {
      // Remove gift from cart
      let chosenItemId = chosenItem.id;
      await removeProduct(chosenItemId);
      refreshCart();
    }
  }
}
function updateGiftWrapping() {
  let giftWrappingInfoButton = document.querySelector('.price-summary__item--gift-wrapping .price-summary__info');
  let giftWrappingButton = document.querySelector('.price-summary__item--gift-wrapping .gift-wrapping-checkbox .checkbox');
  if (giftWrappingInfoButton) {
    // Add gift wrapping product to cart when button is clicked
    giftWrappingButton.addEventListener('click', async () => {
      let productId = giftWrappingButton.closest('.gift-wrapping-checkbox').getAttribute('data-gift-wrapping');

      // Add gift wrapping product to cart + add property
      try {
        // If Gift Wrapping is checked : remove product from the cart, else add it
        if (giftWrappingButton.hasAttribute("checked")) {
          await removeProduct(productId); // Remove gift wrapping from cart
        } else {
          await addGiftWrappingToCart(productId); // Add gift wrapping to cart
        }
      } catch (e) {
        console.error('Error: ', e);
      }
      refreshCart(); // Cart refresh
    });
  }
}
function addFirstVariantToCart(variantId, quantity) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity
    })
  }).then(response => {
    if (response.ok) {
      refreshCart();
    } else {
      console.error('Erreur lors de l\'ajout au panier');
    }
  }).catch(error => console.error('Erreur:', error));
}
function toggleFreeProductsVisibility() {
  // Toggle free products block opening
  let freeProductsBlock = document.querySelector('.free-products');
  let freeProductsHeadingWrapper = document.querySelector('.free-products__heading-wrapper');
  let freeProductsToggleIcon = document.querySelector('.free-products__toggle-icon');
  if (freeProductsBlock) {
    freeProductsHeadingWrapper.addEventListener('click', () => {
      freeProductsBlock.querySelector('.free-products__products').classList.toggle('is-active');
      freeProductsToggleIcon.classList.toggle('is-active');
    });
  }
}